import { render, staticRenderFns } from "./convenios.vue?vue&type=template&id=1aa024d7&scoped=true&"
import script from "./convenios.vue?vue&type=script&lang=js&"
export * from "./convenios.vue?vue&type=script&lang=js&"
import style0 from "./convenios.vue?vue&type=style&index=0&id=1aa024d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa024d7",
  null
  
)

export default component.exports